import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { OrcamentoItensSintetico } from '../../models/orcamentos/orcamento-itens-sintetico';

@Injectable({
  providedIn: 'root'
})

export class OrcamentoItensService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public get15DiasByOrder(id: number, seller_id: number): Observable<OrcamentoItensSintetico[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "order_id": id,
      "seller_id": seller_id
    };

    return this.http.post<OrcamentoItensSintetico[]>(this.baseUrl + "api/OrcamentoItens/Get15DiasByOrder", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }
}
